import { useAppTheme } from '../../../theme/ThemeContext';
import S from './ThemeSettingsStyles';

function ThemeSettings(): JSX.Element {
  const { themeMode, toggleTheme } = useAppTheme();
  const isDarkTheme = themeMode === 'dark';

  return (
    <S.Wrapper>
      <S.BlockContainer>
        <div className="theme-description">
          <h4>Theme</h4>
          <p>Choose how the application appears.</p>
        </div>
        <button
          type="button"
          className="theme-toggle"
          onClick={toggleTheme}
          title={isDarkTheme ? 'Switch to light theme' : 'Switch to dark theme'}
          aria-label={isDarkTheme ? 'Switch to light theme' : 'Switch to dark theme'}
        >
          <span aria-hidden>{isDarkTheme ? '☀️' : '🌙'}</span>
          {isDarkTheme ? 'Light theme' : 'Dark theme'}
        </button>
      </S.BlockContainer>
    </S.Wrapper>
  );
}

export default ThemeSettings;
